import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaShieldAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function Contacts() {
  const { i18n } = useTranslation();

  const LVContacts = () => {
    return (
      <>
        <h2 className="mb-4 text-center">Kontakti</h2>

        <section className="mb-5 text-center">
          <div className="mb-3">
            <h4 className="m-0">
              <FaMapMarkerAlt className="me-2 text-primary" />
              Atbildīgā institūcija
            </h4>
          </div>
          <p>
            <strong>Latvijas Kara muzejs</strong><br />
            Smilšu iela 20,<br />
            Rīga, LV-1050, Latvija
          </p>

          <h4 className="mb-3 mt-4">
            <FaEnvelope className="me-2 text-primary" />
            E-pasts saziņai
          </h4>
          <p>
            <a href="mailto:datubaze@karamuzejs.lv" className="text-decoration-none">
              datubaze@karamuzejs.lv
            </a>
          </p>

          <h4 className="mb-3 mt-4">
            <FaPhone className="me-2 text-primary" />
            Tālrunis
          </h4>
          <p>
            <a href="tel:+37163616238" className="text-decoration-none">
              +371 63616238
            </a>
          </p>
        </section>

        <hr />

        <section className="mt-5">
          <h3 className="mb-4">
            <FaShieldAlt className="me-2 text-primary" />
            Privātuma atruna
          </h3>

          <p>
            Šī tīmekļa vietne pieder un tajā apstrādāto personu datu pārzinis ir <strong>Latvijas Kara
              muzejs</strong>, Reģ. Nr. 90000020203, Smilšu iela 20, Rīga, LV-1050, tālrunis: 63616238,
            elektroniskā pasta adrese:{' '}
            <a href="mailto:pasts@karamuzejs.lv" className="text-decoration-none">
              pasts@karamuzejs.lv
            </a>
          </p>

          <p>
            Jebkura personīgā informācija, kuru jūs brīvprātīgi nododat Latvijas Kara muzejam,
            tiks apstrādāta saskaņā ar Eiropas Parlamenta un Padomes Regulu (ES) 2016/679
            (2016. gada 27. aprīlis) par fizisku personu aizsardzību attiecībā uz personas datu
            apstrādi un šādu datu brīvu apriti. Apmeklējot šo tīmekļa vietni, Latvijas Kara muzejs
            neievāc jūsu personas datus bez jūsu piekrišanas.
          </p>

          <p>
            <strong>Personas datu glabāšana.</strong> Latvijas Kara muzejs apstrādā jūsu personas datus tikai
            tajā laikā, kad esat pierakstījies tīmekļa vietnē. Brīdī, kad jūs atslēdzaties no tīmekļa
            vietnes, jūsu personas dati tiek dzēsti.
          </p>

          <p>
            Gadījumā, ja Jums ir radušies jautājumi par personu datu apstrādi šajā tīmekļa
            vietnē, tad lūdzu sazinieties ar Latvijas Kara muzeja datu aizsardzības speciālistiem,
            rakstot uz e-pasta adresi:{' '}
            <a href="mailto:datuaizsardziba@karamuzejs.lv" className="text-decoration-none">
              datuaizsardziba@karamuzejs.lv
            </a>
          </p>
        </section>
      </>
    );
  };

  const ENContacts = () => {
    return (
      <>
        <h2 className="mb-4 text-center">Contacts</h2>

        <section className="mb-5 text-center">
          <h4 className="mb-3">
            <FaMapMarkerAlt className="me-2 text-primary" />
            Responsible institution
          </h4>
          <p>
            <strong>Latvijas Kara muzejs</strong> (Latvian War Museum)<br />
            20 Smilšu street,<br />
            Riga, LV-1050, Latvia
          </p>

          <h4 className="mb-3 mt-4">
            <FaEnvelope className="me-2 text-primary" />
            Contact email
          </h4>
          <p>
            <a href="mailto:datubaze@karamuzejs.lv" className="text-decoration-none">
              datubaze@karamuzejs.lv
            </a>
          </p>

          <h4 className="mb-3 mt-4">
            <FaPhone className="me-2 text-primary" />
            Phone
          </h4>
          <p>
            <a href="tel:+37163616238" className="text-decoration-none">
              +371 63616238
            </a>
          </p>
        </section>

        <hr />

        <section className="mt-5">
          <h3 className="mb-4">
            <FaShieldAlt className="me-2 text-primary" />
            Privacy Notice
          </h3>

          <p>
            This website is owned by, and the controller of the personal data processed therein
            is, the <strong>Latvian War Museum</strong>, Reg. No. 90000020203, 20 Smilšu iela, Rīga, LV-1050,
            Latvia; tel. 63616238, email:{' '}
            <a href="mailto:pasts@karamuzejs.lv" className="text-decoration-none">
              pasts@karamuzejs.lv
            </a>
          </p>

          <p>
            Any personal information you voluntarily provide to the Latvian War Museum will be
            processed in accordance with Regulation (EU) 2016/679 of the European Parliament
            and of the Council (27 April 2016) on the protection of natural persons with regard to
            the processing of personal data and on the free movement of such data. When
            visiting this website, the Latvian War Museum does not collect your personal data
            without your consent.
          </p>

          <p>
            <strong>Storage of personal data.</strong> The Latvian War Museum processes your personal data
            only for the duration of your logged-in session on the website. Once you log out, your
            personal data is deleted.
          </p>

          <p>
            If you have any questions regarding the processing of personal data on this website,
            please contact the Latvian War Museum's data protection specialists by writing to:{' '}
            <a href="mailto:datuaizsardziba@karamuzejs.lv" className="text-decoration-none">
              datuaizsardziba@karamuzejs.lv
            </a>
          </p>
        </section>
      </>
    );
  };

  return (
    <Container className="py-5">
      <Card className="shadow-lg rounded text-start">
        <Card.Body className="p-4">
          {i18n.language === 'lv' ? <LVContacts /> : <ENContacts />}
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Contacts;